import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useSubsequentEffect } from '@carvana/vdp-react-hooks';
import { useContext, useRef } from 'react';
import SearchSource from '~/constants/SearchSource';
import SearchEventsDataContext from '~/contexts/SearchEventsDataContext';
import { useUserLocation } from '~/contexts/UserContext';

export default function useLogZipCodeChanges() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { zip } = useUserLocation();
  const previousZip = useRef(zip);

  useSubsequentEffect(() => {
    trackEvent('zip code changed', {
      previousZip: previousZip.current,
      newZip: zip
    });
    previousZip.current = zip;
  }, [trackEvent, zip]);

  useSubsequentEffect(() => {
    setSearchSource(SearchSource.Location);
  }, [zip, setSearchSource]);
}
